import atrium from "./modals/atrium";
import { ModalWrapper } from "src/utils/fw";
import { auditoriumCloseDate, isMember, leaderboardOptIn, modalColor } from "../utils";
import LeaderboardModal from "./modals/LeaderboardModal";
import VideoModal from "src/components/VideoModal";

const NomMemberModal = ({leaderboard = false, optIn = false}) => {

	return <ModalWrapper dismissStyle={{
        width: "2%",
        height: "3%",
        left: "90.9%",
        top: "11%",
    }} dismissHTML="X" wrapperStyle={{background: "black", textAlign: "center"}}>
		<h1 style={{color: "white"}}>
			{leaderboard && !optIn ? "Opt In to Leaderboard to access" : "This is an ISF Members Only area" }
		</h1>
	</ModalWrapper>
}


const memberLinks = [
	{
		height: "13.6%",
		label: "FAQ",
		left: "23.3%",
		top: "76.7%",
		width: "5.4%",
		href: "https://assets.swoogo.com/uploads/4617683-672cef8a8addb.pdf",
		target: "_blank"
	},
	{
		label: "Exploration Zone",
		height: "24.2%",
		href: "/exploration-zone",
		left: "56.2%",
		top: "12%",
		width: "13.6%",
		modal: !isMember ? <NomMemberModal /> : undefined,

	}
]

memberLinks.push({
	label: "Leaderboard",
	width: "9.6%",
	height: "7.2%",
	left: "73.2%",
	top: "68%",
	modalOverrides: {
		dismissHTML:"X",
		dismissStyle:{color: "white", fontSize: "18px", top: "9px", right: "13px"},
	},
	modal: !isMember ? <NomMemberModal /> : <LeaderboardModal />
})

const general = [
	{
		label: "Auditorium",
		height: "20.2%",
		href: new Date() < auditoriumCloseDate ? "/auditorium-hall" : undefined,
		left: "57.2%",
		top: "56%",
		width: "12.6%",
		modal: new Date() < auditoriumCloseDate ? (!isMember ? <NomMemberModal /> : undefined) : <ModalWrapper wrapperStyle={{background: modalColor, textAlign: "center"}}>
			<h1 style={{color: "white"}}>The Auditorium is now closed.</h1>
			<p style={{color: "white"}}>Please head over to our On-Demand Rooms to view session recordings, and browse through our ISF Exploration Zone and Exhibition Hall until Wednesday 4 December.</p>
		</ModalWrapper>,
		modalOverrides: {
			dismissHTML:"X",
			dismissStyle:{color: "white", fontSize: "18px", top: "9px", right: "13px"},
		},
	},
	{
		label: "Exibition Hall",
		height: "26.2%",
		href: "/exhibition-hall",
		left: "26.2%",
		top: "57%",
		width: "11.6%",
	},
	{
		label: "On Demand",
		href: new Date() > new Date("2024-11-11 08:00:00-05:00") ? "/on-demand" : undefined,
		width: "7.6%",
		height: "18.2%",
		left: "28.2%",
		top: "37%",
		modal: !isMember ? <NomMemberModal /> : (new Date() > new Date("2024-11-11 08:00:00-05:00") ? undefined : <ModalWrapper wrapperStyle={{background: modalColor}}>
			<h2 style={{color: "white"}}>On-Demand sessions will be released each day at 08:00 EST, beginning on Monday 11 November.</h2>
		</ModalWrapper>),
		modalOverrides: {
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		}
	},
	{
		height: "13.4%",
		label: "Welcome",
		left: "53.5%",
		top: "41.4%",
		width: "18.6%",
		modal: <ModalWrapper wrapperStyle={{
            backgroundColor: modalColor, 
            color: "white",
            aspectRatio: "16 / 9",
            width: "50%",
            minWidth: "700px"}}>
            <VideoModal url="https://player.vimeo.com/video/991467648?autoplay=1" />
        </ModalWrapper>,
		modalOverrides: {
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		}
	},
	{
		width: "17.8%",
		height: "20.1%",
		left: "29.6%",
		top: "74.8%",
		label: "Help Desk",
		isExternal: false,	
		onClick: () => {
			openSmartSupp()
		}
	}
]

export default {
	background: "https://assets.swoogo.com/uploads/full/4570981-6719647b715cf.png",
	default: true,
	links: [...general, ...memberLinks],
	extras: atrium,
	name: "atrium",
}
